import { protrakApiClient, useProtrakApi } from '../../Core';
import { useApi } from '../../Core';

const userBase = '/users';

export const TOKEN_CACHE_KEY = '__coco_protrak_user_token__';

export const invalidateToken = (userData, authContext) => {
  let contextToPass;
  if (authContext) {
    contextToPass = authContext;
  } else {
    // because SPA calls this method from authcontext itself.
    contextToPass = { userData: userData };
  }
  protrakApiClient(
    `${userBase}/invalidateToken?accesstoken=${userData.accessToken}`,
    {
      method: 'PUT'
    },
    contextToPass
  );
};

export function useValidateAccount() {
  const { state, run } = useApi(
    { requestConfig: validateUserPromise },
    { defer: true }
  );
  return [state, run];
}

const validateUserPromise = ({ userEmail }) => {
  return {
    endpoint: `${userBase}/${userEmail}/validateAccount`,
    config: {
      method: 'GET'
    }
  };
};

export function useAuthenticate() {
  const { state, run } = useApi(
    { requestConfig: authenticate },
    { defer: true }
  );
  return [state, run];
}

const authenticate = ({
  userEmail,
  password,
  provider,
  accessToken,
  orgId
}) => {
  return {
    endpoint: `${userBase}/authenticate`,
    config: {
      method: 'POST',
      data: {
        userEmail,
        password,
        provider,
        accessToken,
        tenantId: orgId,
        clientType: 'Web',
        clientDetails: 'Protrak SPA'
      }
    }
  };
};

export function useForgotPassword() {
  const { state, run } = useApi(
    { requestConfig: forgotPassword },
    { defer: true }
  );
  return [state, run];
}

const forgotPassword = ({ userEmail, tenantId }) => {
  return {
    endpoint: `${userBase}/forgotPassword`,
    config: {
      method: 'PUT',
      data: {
        userEmail: userEmail,
        tenantId: tenantId
      }
    }
  };
};

export function useChangePassword() {
  const { state, run } = useProtrakApi(
    { requestConfig: changePassword },
    { defer: true }
  );
  return [state, run];
}

const changePassword = ({ currentPassword, newPassword }) => {
  return {
    endpoint: `${userBase}/changePassword`,
    config: {
      method: 'PUT',
      data: {
        oldPassword: currentPassword,
        newPassword: newPassword
      }
    }
  };
};
